import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {validate} from 'validate.js';
import {
    Row, Col, Form,
    FormGroup, FormFeedback, Input,
    Button
  } from 'reactstrap';

import { authActions } from '../../../actions';
import { getFullUser } from '../../../selectors';

import '../Auth.css';

const constraints = {
    email: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
        email: {
            message: "Doesn't look like a valid email"
        }
    },
    password: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        }
    }
};

class Login extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            globalError: '',
            email: {
                value: '',
                validateCSS: '',
                errors: []
            },
            password: {
                value: '',
                validateCSS: '',
                errors: []
            }
        };
    }

    validateInput(input, inputName) {
        let err = validate.single(input, constraints[inputName]);
        const inputState = this.state[inputName];

        if(!inputState)
            return undefined;

        if(!err){
            inputState.errors = [];
            inputState.validateCSS = 'has-success'
        } else {
            inputState.errors = err;
            inputState.validateCSS = 'has-danger'
        }
        this.setState({ [inputName]: inputState });
        return err;
    }

    handleChange = (event) => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        const inputState = this.state[name];
        inputState.value = value;

        this.setState({ globalError: '' });
        this.setState({ [name]: inputState });
    }

    submitForm(e) {
        e.preventDefault();
        const { email, password } = this.state;
        const formElements = [...e.target.elements];
        const errors = formElements.map((fe) => {
                return this.validateInput(fe.value, fe.name);
            })
            .filter((fe) => {
                return fe;
            });
        if(errors.length === 0){
            this.props.login(email.value, password.value);
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.user && this.props.user.error && (prevProps.user !== this.props.user)) {
            this.setState({ globalError: 'Invalid credentials, try again!' });
        }
    }

    renderError(){
        if(this.state.globalError) {
            return <div className="auth-form-error">{this.state.globalError}</div>
        }
    }

    render() {
        const { email, password } = this.state;

        return (
            <div>
                <div className="auth">
                    <div className="auth__row auth__center">
                        <div className="auth__text">
                            <h1 className="auth__text__header">Welcome to TBayShinny</h1>
                        </div>
                    </div>
                    <div className="auth__row auth__center">
                        <div className="auth__box">
                            <div className="auth-form">
                                <h3 className="auth-form__header">PLEASE LOG IN</h3>
                                { this.renderError() }
                                <Form className="form" onSubmit={ (e) => this.submitForm(e) }>
                                    <Row form>
                                        <Col>
                                            <FormGroup>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="emailInput"
                                                    placeholder="Email"
                                                    value={ email.value }
                                                    valid={ this.state.email.validateCSS === 'has-success' }
                                                    invalid={ this.state.email.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormFeedback>
                                                    {this.state.email.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row form>
                                        <Col>
                                            <FormGroup>
                                                <Input
                                                    type="password"
                                                    name="password"
                                                    id="passwordInput"
                                                    placeholder="Password"
                                                    value={ password.value }
                                                    valid={ this.state.password.validateCSS === 'has-success' }
                                                    invalid={ this.state.password.validateCSS === 'has-danger' }
                                                    onChange={
                                                        (e) => {
                                                            this.validateInput(e.target.value, e.target.name);
                                                            this.handleChange(e)
                                                        }
                                                    }
                                                />
                                                <FormFeedback>
                                                    {this.state.password.errors[0]}
                                                </FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="auth-form__item auth-form__item_forgot">
                                        <Link to='/forgot' className="auth-form__forget">Forget Password?</Link>
                                    </div>
                                    <div className="login-form__actions">
                                        <Button color="primary" type="submit" className="auth-form__submit">
                                            Log in
                                        </Button>
                                        <span className="login-form__register">
                                            <Link to='/register' className="auth-form__register__link">Register</Link> if you dont have an account
                                        </span>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state){
    return {
        user: getFullUser(state)
    };
}

export default connect(mapStateToProps, authActions)(Login);



// WEBPACK FOOTER //
// ./src/components/Auth/Login/Login.js